import React, { useContext} from 'react';
import styled from 'styled-components/macro';
import { Field, TextField, CheckboxField, SelectField } from '../UI';
import EditorContext from '../../../modules/contexts/editor';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DuplicateIcon from '@material-ui/icons/FileCopyOutlined';
import deletePNG from '../../../assets/images/delete.png';
import deepClone from 'deep-clone';

const BoxWrapper = styled.div`
    border-bottom: thin solid lightgray;
`;

const ListWrapper = styled(Field)`
    display: table;
    width: calc(100% - 20px);
`;

const FieldLabel = styled.div`
    font-weight: bold;
    padding: 7px;
    margin-bottom: 5px;
`;

const ListRow = styled.div`
    display: table-row;
    flex-direction: row;
`;

const ListField = styled.div`
    display: table-cell;
    width: min-content;
    position: relative;
`;

const Delete = styled.img`
    width: 24px;
    content: url(${deletePNG});
    align-self: center;
    cursor: pointer;
    position: absolute;
    bottom: 6px;
    left: 2px
`;

const Duplicate = styled.div`
    width: 24px;
    align-self: center;
    cursor: pointer;
    position: absolute;
    bottom: 6px;
    left: -5px
`;

const AddBox = styled.div`
    font-weight: bold;
    //border: thin solid #ababab;
    //border-radius: 50%;
    cursor: pointer;
    padding: 2px;
    margin: 8px 8px;
    width: 17px;
    height: 17px;
    text-align: center;
    font-size: 16px;
    background-color: #ffffff;
`;

export const List = ({ node, field }) => {
    /* This field element allows for a fully configurable dynamic list builder,
       essentially a generic version of the List and Parts field elements.

       It's configurable by adding a "listFields" array to the field definition.
       The listFields are objects and should have as properties:
        - label (any text)
        - name (i.e. a valid programmatic variable)
        - type:
            - text
            - checkbox (todo)
            - select (todo)

        (select field will require sub-configuration)
    */
    const editor = useContext(EditorContext);

    const itemFieldChanged = (itemIndex, fieldName, value) => {
        editor.updateElementListFieldItem(node, field, itemIndex, fieldName, value);
        editor.commitNodeUpdate(node);
    };

    const newItem = () => {
        const obj = {};
        for (let listField of field.listFields) {
            obj[listField.name] = listField.type === 'checkbox' ? false : '';
        }
        return obj;
    }

    const addItem = () => {
        const listItemsCopy = [...field.listItems];
        listItemsCopy.push(newItem());
        editor.updateElementListField(node, field, listItemsCopy);
        editor.commitNodeUpdate(node);
    };

    const deleteItem = (i) => {
        const listItemsCopy = [...field.listItems];
        listItemsCopy.splice(i, 1);
        editor.updateElementListField(node, field, listItemsCopy);
        editor.commitNodeUpdate(node);
    };

    const duplicateItem = (i) => {
        const listItemsCopy = [...field.listItems];
        listItemsCopy.splice(i, 0, deepClone(listItemsCopy[i]));
        editor.updateElementListField(node, field, listItemsCopy);
        editor.commitNodeUpdate(node);
    };

    const listFieldWidth = { choice: '30%', step: '65%', fragment: '95%' }; // mild hack, these should be from new subfields in lessonDefs, add to all lessons later

    return (
        <BoxWrapper>
            <FieldLabel>{field.label}</FieldLabel>
            <ListWrapper>
                <ListRow>
                    { field.listFields.map((listField) => 
                        <ListField key={listField.name}>{listField.label}</ListField>
                    )}
                </ListRow>
                { field.listItems.map((item, i) => {
                    return (
                        <ListRow key={`item${i}`}>
                            { field.listFields.map((listField, j) => {
                                const itemFieldValue = item[listField.name];
                                const key = `item-${i}:field-${j}`;

                                if (itemFieldValue === null) {
                                    return <ListField key={key} />
                                }

                                switch (listField.type) {
                                    case 'text':
                                        return (
                                            <ListField key={key} style={{ width: listFieldWidth[listField.name] || 'auto' }}>
                                                <TextField
                                                    inputRef={input => { if (input) input.value = itemFieldValue; }}
                                                    onBlur={e => itemFieldChanged(i, listField.name, e.target.value)} 
                                                />
                                            </ListField>
                                        );
                                    case 'checkbox':
                                        <ListField key={key}>Checkbox field not yet implemented.</ListField>
                                    case 'select':
                                        <ListField key={key}>Select field not yet implemented.</ListField>
                                    default:
                                        return <ListField key={key}>Field type "{listField.type}" not recognized.</ListField>;
                                }
                            })}
                            <ListField><Duplicate onClick={e => duplicateItem(i)}><DuplicateIcon /></Duplicate></ListField>
                            <ListField><Delete onClick={e => deleteItem(i)} /></ListField>
                        </ListRow>
                    );
                })}
                <AddBox onClick={addItem}><AddCircleOutlineIcon /></AddBox>
            </ListWrapper>
        </BoxWrapper>
    );
};
